import HistoryIconSvg from "PFIcons/history.svg";
import React from "react";

import BottomCardButton from "../bottom_cards/bottom_card_button";
import css from "./booking_history_button.module.scss";

const HistoryIcon: React.FC<any> = (props) => <HistoryIconSvg {...props} width={30} height={30} />;

interface IProps {
  count: number;
  expanded: boolean;
  selected: boolean;
  onClick: () => void;
}

const BookingHistoryButton = (props: IProps) => (
  <BottomCardButton {...props} icon={HistoryIcon} className={css.button} />
);

export default BookingHistoryButton;
